export default "__VITE_ASSET__p6zTa5uD__"